import classNames from "classnames";
import { FormInput } from "components/Forms/FormInput";
import { createLogger } from "logging";
import { useTranslations } from "providers";
import React from "react";

const logger = createLogger("BsSwitch");

interface BsSwitchProps extends FormInput {
  className?: string;
  disabled?: boolean;
  onText?: string;
  offText?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

export const BsSwitch: React.FC<BsSwitchProps> = ({
  name,
  className,
  checked,
  onChange,
  onText,
  offText,
  disabled,
}) => {
  const i18n = useTranslations();

  onText = onText || i18n.Yes;
  offText = offText || i18n.No;
  const containerClass = classNames("form-check", "form-switch", className);

  return (
    <div className={containerClass}>
      <input
        type="checkbox"
        id={name}
        name={name}
        disabled={disabled}
        className="form-check-input"
        onChange={(e) => {
          const newChecked = e.target.checked;
          logger.debug(`onChange(): ${name}: ${checked} -> ${!newChecked}`);
          return onChange(newChecked);
        }}
        checked={checked}
      />

      <label className="form-check-label" htmlFor={name}>
        {checked ? onText : offText}
      </label>
    </div>
  );
};
